import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Slider from "react-slick"

import Office_studyZone1 from "../../../static/space/studyoffice/studyoffice-study1.jpg"
import Office_studyZone2 from "../../../static/space/studyoffice/studyoffice-study2.jpg"
import Office_studyZone3 from "../../../static/space/studyoffice/studyoffice-study3.jpg"
import Office_studyZone4 from "../../../static/space/studyoffice/studyoffice-study4.jpg"
import Office_studyZone5 from "../../../static/space/studyoffice/studyoffice-study5.jpg"

const Container = styled.div`
  padding: 1vw 0 7vw;

  .title-slide {
    margin: 3vw 0 2vw;
  }
  .office-studyzone-slide-first img {
    width: 60vw;
    margin-left: auto;
    margin-right: auto;
  }
  .office-studyzone-slide-first {
    height: 30vw;
  }

  .office-studyzone-slide-second {
    height: 7.5vw;
  }

  .office-studyzone-slide-second img {
    width: 14.5vw;
    height: 7.5vw;
    margin: 0 auto;
  }

  .slick-slider {
    width: 60.4vw;
    margin: 3vw auto;
  }

  .slick-next,
  .slick-prev,
  .slick-next:before,
  .slick-prev:before {
    display: none;
  }

  .hide-480 {
    display: block;
  }

  .show-480 {
    display: none;
  }

  @media screen and (max-width: 480px) {
    .hide-480 {
      display: none;
    }

    .show-480 {
      display: block;
    }

    img.slide-img-480 {
      width: 80vw;
      margin: 0 auto 2.5vw;
      display: block;
    }
  }
`

const studyoffice_study = () => {
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let slider1: any = []
  let slider2: any = []

  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  return (
    <Container>
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <div className="show-480">
        <img
          className="slide-img-480"
          src={Office_studyZone1}
          alt="오피스 스터디존1"
        />
        <img
          className="slide-img-480"
          src={Office_studyZone2}
          alt="오피스 스터디존2"
        />
        <img
          className="slide-img-480"
          src={Office_studyZone3}
          alt="오피스 스터디존3"
        />
        <img
          className="slide-img-480"
          src={Office_studyZone4}
          alt="오피스 스터디존4"
        />
        <img
          className="slide-img-480"
          src={Office_studyZone5}
          alt="오피스 스터디존5"
        />
      </div>
      <div>
        <Slider
          className="title-slide hide-480"
          asNavFor={nav2}
          ref={slider => (slider1 = slider)}
        >
          <div className="office-studyzone-slide-first">
            <img
              src={Office_studyZone1}
              alt="오피스 스터디존1"
              style={{ marginTop: "-13vw" }}
            />
          </div>
          <div className="office-studyzone-slide-first">
            <img src={Office_studyZone2} alt="오피스 스터디존2" />
          </div>
          <div className="office-studyzone-slide-first">
            <img src={Office_studyZone3} alt="오피스 스터디존3" />
          </div>
          <div className="office-studyzone-slide-first">
            <img src={Office_studyZone4} alt="오피스 스터디존4" />
          </div>
          <div className="office-studyzone-slide-first">
            <img src={Office_studyZone5} alt="오피스 스터디존5" />
          </div>
        </Slider>
        <Slider
          className="same-title-slide hide-480"
          asNavFor={nav1}
          ref={slider => (slider2 = slider)}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
        >
          <div className="office-studyzone-slide-second">
            <img src={Office_studyZone1} alt="오피스 스터디존1" />
          </div>
          <div className="office-studyzone-slide-second">
            <img src={Office_studyZone2} alt="오피스 스터디존2" />
          </div>
          <div className="office-studyzone-slide-second">
            <img src={Office_studyZone3} alt="오피스 스터디존3" />
          </div>
          <div className="office-studyzone-slide-second">
            <img src={Office_studyZone4} alt="오피스 스터디존4" />
          </div>
          <div className="office-studyzone-slide-second">
            <img src={Office_studyZone5} alt="오피스 스터디존5" />
          </div>
        </Slider>
      </div>
    </Container>
  )
}

export default studyoffice_study
